import { navigation } from '@/navigation';
import { SETTINGS_SECTIONS, settingsSectionHref } from './settings-sections';

const CODE_LISTS = SETTINGS_SECTIONS.filter(section => section.group === 'codeLists');

/**
 * Where an old `/code-lists?tab=…` link leads now: the code list that held that tab, the first
 * one without a tab or for an unknown one.
 */
export function legacyCodeListsTarget(search: string): string {
  const tab = new URLSearchParams(search).get('tab');
  const list = CODE_LISTS.find(section => section.legacyTabs.some(legacy => legacy === tab));
  return list ? settingsSectionHref(list) : navigation.codeLists();
}
